import { Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';

declare var firebase: any;
@Injectable()
export class AuthService implements OnInit {

    constructor(private router: Router) {

    }

    ngOnInit(): void {
    }


    isLoggedIn() {
        const user = firebase.auth().currentUser;
        if (user) {
            return true;
        } else {
            return false;
        }
    }

    getUserIdToken(): Observable<string> {
        const user = this.getUser();
        return user ? Observable.fromPromise(user.getIdToken()) : Observable.of(null)
    }

    getUser() {
        return firebase.auth().currentUser;
    }

    getUserEmail() {
        if (this.isLoggedIn()) {
            return this.getUser()['email'];
        } else {
            return 'Who are you?';
        }
    }

    logOut() {
        const self = this;
        firebase.auth().signOut().then(function() {
            self.router.navigate(['pages/login']);
          }).catch(function(error) {
            console.error('Error during signing out', error)
        });
    }

    logInUser(email, password) {
        firebase.auth().signInWithEmailAndPassword(email, password).catch(function(error) {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // ...
            console.log(errorMessage);
        });
    }

}



// WEBPACK FOOTER //
// /Users/pkovacs/Documents/Development/ngsAlpha/ngs_alpha_ui/src/app/service/auth.service.ts